import { render, staticRenderFns } from "./HpSubTitle.vue?vue&type=template&id=0cc48f9a&scoped=true&"
import script from "./HpSubTitle.vue?vue&type=script&lang=ts&"
export * from "./HpSubTitle.vue?vue&type=script&lang=ts&"
import style0 from "./HpSubTitle.vue?vue&type=style&index=0&id=0cc48f9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc48f9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
